import {
  Box,
  Flex,
  Heading,
  Text,
  Stack,
  Card,
  CardHeader,
  CardBody,
  Spinner,
  Divider,
  Button,
} from "@chakra-ui/react";
import { Link as RouterLink, useLocation, useParams } from "react-router-dom";
import { DevelopmentIcon } from "../../assets/icons";
import { useTranslation } from "react-i18next";
import { useDevelopment } from "../../hooks/useDevelopment";
import ReportSurveyHeader from "./ReportSurveyHeader";

const Development = ({ isHub }) => {
  const { t } = useTranslation();
  const { organizationSurveyId } = useParams();
  const location = useLocation();
  const isSchoolReport = location.pathname.startsWith("/app/organization/results/");

  const { developmentData, loading, error } = useDevelopment(organizationSurveyId, t);

  if (loading) return <Spinner size="xl" />;
  if (error) return <Text color="red.500">{error}</Text>;

  return (
    <Box>
      <ReportSurveyHeader survey={developmentData} />

      <Flex align={{ base: "start", md: "center" }} justify="space-between" gap={4} mb={4}>
        <Flex align="center">
          <DevelopmentIcon />
          <Heading as="h1" size="2xl" color="#e5923b" ml={3}>
            {t("reports.development.title")}
          </Heading>
        </Flex>
        {isSchoolReport ? (
          <Button
            as={RouterLink}
            to="/app/organization/workbook"
            state={{ organizationSurveyId }}
            colorScheme="blue"
            flexShrink={0}
          >
            {t("organization.open_workbook", "Open Workbook")}
          </Button>
        ) : null}
      </Flex>

      <Text fontSize="xl" color="gray.500" mb={4}>
        {t("reports.development.description")}
      </Text>
      <Divider />

      <Box bg="#fbe4d5" p={6} borderRadius="md" w="full" mt={4}>
        <Text fontSize="2xl" fontWeight="bold" color="#e5923b">
          {t(`reports.layout.${developmentData.lowest_area.toLowerCase()}`)}
        </Text>
      </Box>

      <Divider />

      <Heading as="h3" size="lg" mt={6} textAlign="left">
        {t("reports.development.focus_factors")}
      </Heading>

      <Stack spacing={4} w="full">
        {developmentData.bottom_factors.map((factor, index) => (
          <Flex
            key={index}
            direction={{ base: "column", md: "row" }}
            gap={4}
          >
            <Card flex="1" shadow="md" borderRadius="md" p={4} bg="gray.50">
              <CardHeader>
                <Heading size="md" color="#e5923b">
                  {factor.factor}
                </Heading>
              </CardHeader>
              <CardBody>
                <Text>{factor.description}</Text>
              </CardBody>
            </Card>
            <Card flex="1" shadow="md" borderRadius="md" p={4} bg="gray.50">
              <CardBody>
                {factor.questions && factor.questions.length > 0 && (
                  <Box>
                    <Box as="ul" pl={4}>
                      {factor.questions.slice(0, 3).map((question, qIndex) => (
                        <Box as="li" key={qIndex}>
                          {question.text}
                        </Box>
                      ))}
                    </Box>
                  </Box>
                )}
              </CardBody>
            </Card>
          </Flex>
        ))}
      </Stack>
    </Box>
  );
};

export default Development;
